<template>
    <el-select :value="value" class="select" :placeholder="$t('shared.pleaseSelectShippingMethod')" @change="$emit('input', $event)" :disabled="disabled">
        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: 'shipping-method-selector',
        props: ['value', 'disabled'],
        data(vm) {
            return {
                loading: false,
                roles: [
                    {
                        id: '0',
                        name: vm.$t('common.express')
                    },
                    {
                        id: '1',
                        name: vm.$t('common.expressSat')
                    },
                    {
                        id: '4',
                        name: vm.$t('common.standard')
                    },
                    {
                        id: '5',
                        name: vm.$t('common.other')
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/ShippingMethodSelector.vue